/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetTermsOptions, GetTermsResponses } from '../../models/GetTerms'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Terms
 * {@link /user/terms}
 */
export function getTerms<ThrowOnError extends boolean = true>(options: Options<GetTermsOptions, ThrowOnError> = {}): Promise<UnwrappedResult<GetTermsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/user/terms', ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetTermsResponses, ThrowOnError>>
}
